import type {
    ProgramsFilterSelections,
    ProgramsPreferencesState,
    ProgramsSortSelection,
    ProgramsStickyFiltersAndSort
} from '@makemydeal/dr-dash-types';
import type { OfferType } from '@makemydeal/dr-platform-types';
import type { Reducer } from 'redux';
import { SET_PROGRAMS_FILTERS, SET_PROGRAMS_SORT } from '../actionTypes/programsPreferencesActionTypes';

export type ProgramsPreferencesReducer = Reducer<ProgramsPreferencesState>;

export const initialState: ProgramsPreferencesState = {};

const updateOfferTypeEntry = (
    state: ProgramsPreferencesState,
    offerType: OfferType,
    patch: Partial<ProgramsStickyFiltersAndSort>
): ProgramsPreferencesState => ({
    ...state,
    stickyFiltersAndSort: {
        ...state.stickyFiltersAndSort,
        [offerType]: { ...state.stickyFiltersAndSort?.[offerType], ...patch }
    }
});

export const reducer: ProgramsPreferencesReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_PROGRAMS_FILTERS: {
            const { offerType, filters }: { offerType: OfferType; filters: ProgramsFilterSelections } = action.payload;
            return updateOfferTypeEntry(state, offerType, { filters });
        }
        case SET_PROGRAMS_SORT: {
            const { offerType, sort }: { offerType: OfferType; sort: ProgramsSortSelection | null } = action.payload;
            return updateOfferTypeEntry(state, offerType, { sort });
        }
        default: {
            return state;
        }
    }
};
